module.exports = __webpack_public_path__ + "static/media/Aquarius-Bold.06331f12.ttf";